/* eslint-disable max-classes-per-file */
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { IMapGeometryPoint } from "~app/common/components/map/map.settings";
import { EventService, IEvent } from "../../../../../common/services/cqs/event.service";
import { DestineringsraderUpdatedEvent } from "../tpl-omdestinera/components/begransa-virkesorderrader-modal/begransa-virkesorderrader-events";

export class TplTransportAvstandEventHandler {
    private readonly ngUnsubscribe$ = new Subject<void>();

    constructor(
        private readonly eventService: EventService) {
    }

    onViapunktAdded(callback: (e: ViapunktAddedEvent) => void) {
        this.eventService
            .subscribeEvent<ViapunktAddedEvent>(ViapunktAddedEvent.type)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(event => callback(event));
    }

    onToggleViapunktReadonly(callback: (e: ToggleViapunktReadonlyEvent) => void) {
        this.eventService
            .subscribeEvent<ToggleViapunktReadonlyEvent>(ToggleViapunktReadonlyEvent.type)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(event => callback(event));
    }

    onViapunktDeleted(callback: (e: DeleteViapunktEvent) => void) {
        this.eventService
            .subscribeEvent<DeleteViapunktEvent>(DeleteViapunktEvent.type)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(event => callback(event));
    }

    onViapunktModified(callback: (e: ViapunkterModifiedEvent) => void) {
        this.eventService
            .subscribeEvent<ViapunkterModifiedEvent>(ViapunkterModifiedEvent.type)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(event => callback(event));
    }

    onPointLocationChanged(callback: (e: PointLocationChangedEvent) => void) {
        this.eventService
            .subscribeEvent<PointLocationChangedEvent>(PointLocationChangedEvent.type)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(event => callback(event));
    }

    onRuttChanged(callback: (e: RuttChangedEvent) => void) {
        this.eventService
            .subscribeEvent<RuttChangedEvent>(RuttChangedEvent.type)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(event => callback(event));
    }

    onStartpunktReset(callback: (e: StartpunktResetEvent) => void) {
        this.eventService
            .subscribeEvent<StartpunktResetEvent>(StartpunktResetEvent.type)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(event => callback(event));
    }

    onDestineringsraderUpdated(callback: (event: DestineringsraderUpdatedEvent) => void) {
        this.eventService
            .subscribeEvent<DestineringsraderUpdatedEvent>(DestineringsraderUpdatedEvent.type)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(callback);
    }

    unsubscribe() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }
}

export class ViapunktAddedEvent implements IEvent {
    $type: string;
    point: any;
    coords: any;
    static readonly type = "ViapunktAddedEvent";
    constructor(point: any, coords: any) {
        this.$type = ViapunktAddedEvent.type;
        this.point = point;
        this.coords = coords;
    }
}

export class DeleteViapunktEvent implements IEvent {
    $type: string;
    point: any;
    static readonly type = "DeleteViapunktEvent";
    constructor(point: any) {
        this.$type = DeleteViapunktEvent.type;
        this.point = point;
    }
}

export class ToggleViapunktReadonlyEvent implements IEvent {
    $type: string;
    readonly: boolean;
    static readonly type = "ToggleViapunktReadonlyEvent";
    constructor(readonly: boolean) {
        this.$type = ToggleViapunktReadonlyEvent.type;
        this.readonly = readonly;
    }
}

export class ViapunkterModifiedEvent implements IEvent {
    $type: string;
    uppdateraAllaMottagningsplatser: boolean;
    static readonly type = "ViapunkterModifiedEvent";
    constructor(uppdateraAllaMottagningsplatser = false) {
        this.$type = ViapunkterModifiedEvent.type;
        this.uppdateraAllaMottagningsplatser = uppdateraAllaMottagningsplatser;
    }
}

export class PointLocationChangedEvent implements IEvent {
    $type: string;
    geometry: IMapGeometryPoint;
    geometryBeforeChange: IMapGeometryPoint;
    static readonly type = "PointLocationChangedEvent";
    constructor(geometry: IMapGeometryPoint, geometryBeforeChange: IMapGeometryPoint) {
        this.$type = PointLocationChangedEvent.type;
        this.geometry = geometry;
        this.geometryBeforeChange = geometryBeforeChange;
    }
}

export class RuttChangedEvent implements IEvent {
    $type: string;
    arbetsorderId: number;
    static readonly type = "RuttChangedEvent";
    constructor(arbetsorderId: number) {
        this.$type = RuttChangedEvent.type;
        this.arbetsorderId = arbetsorderId;
    }
}

export class RuttExtraKmChangedEvent implements IEvent {
    $type: string;
    extraKm: number;
    arbetsorderId: number;
    static readonly type = "RuttExtraKmChangedEvent";
    constructor(extraKm: number, arbetsorderId: number) {
        this.$type = RuttExtraKmChangedEvent.type;
        this.extraKm = extraKm;
        this.arbetsorderId = arbetsorderId;
    }
}

export class AnvandVerkligaAvlaggChangedEvent implements IEvent {
    $type: string;
    arbetsorderId: number;
    anvandVerkligaAvlagg: boolean;
    static readonly type = "AnvandVerkligaAvlaggChangedEvent";
    constructor(arbetsorderId: number, anvandVerkligaAvlagg: boolean) {
        this.$type = AnvandVerkligaAvlaggChangedEvent.type;
        this.arbetsorderId = arbetsorderId;
        this.anvandVerkligaAvlagg = anvandVerkligaAvlagg;
    }
}

export class StartpunktResetEvent implements IEvent {
    $type: string;
    easting: number;
    northing: number;
    static readonly type = "StartpunktResetEvent";
    constructor(easting: number, northing: number) {
        this.$type = StartpunktResetEvent.type;
        this.easting = easting;
        this.northing = northing;
    }
}
